import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { rootContainer, TYPE } from "../container/root";

export interface ITermsAcceptanceSettings {
    terms_acceptance_required: boolean;
    terms_review_notice_visible: boolean;
    terms_version: string;
    terms_content?: string;
}

@injectable()
class TermsAcceptanceService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async acceptTerms(termsVersion: string): Promise<ITermsAcceptanceSettings> {
        const res = await this.httpService.post<IApiResponse<ITermsAcceptanceSettings>>(
            '/rms-api/accept-terms',
            { terms_version: termsVersion }
        );
        return res.payload;
    }
}

export default TermsAcceptanceService;
